// extracted by mini-css-extract-plugin
export var archive = "index-module--archive--kHBLk";
export var content = "index-module--content--ivG0M";